import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export default function RequirePasswordChange({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  const mustChange = Boolean(user?.mustChangePassword);

  // If not logged in, let your normal auth flow handle it
  if (!user) return children;

  // If user must change password, only allow access to change-password route
  if (mustChange && location.pathname !== "/change-password") {
    return <Navigate to="/change-password" replace state={{ from: location }} />;
  }

  // If user does NOT need to change password, prevent visiting the change page
  if (!mustChange && location.pathname === "/change-password") {
    return <Navigate to="/" replace />;
  }

  return children;
}
